import { addClass, on, removeClass, selectAll } from 'helpers/dom'

const selectors = {
  INPUT_CLASS: 'input',
  FOCUS_CLASS: 'focus:!ring-0',
  ACTIVATED_INPUT_CLASS: 'js-activated-input'
}

on('click', (event) => {
  const el = event.target

  const currentActivatedInputEls = selectAll(`.${selectors.ACTIVATED_INPUT_CLASS}`)

  if (currentActivatedInputEls.length) {
    removeClass(selectors.FOCUS_CLASS, currentActivatedInputEls)
    removeClass(selectors.ACTIVATED_INPUT_CLASS, currentActivatedInputEls)
  }

  if (el.classList.contains(selectors.INPUT_CLASS)) {
    addClass(selectors.FOCUS_CLASS, el)
    addClass(selectors.ACTIVATED_INPUT_CLASS, el)
  }
}, document)
